export default __webpack_public_path__ + "static/cognizant-e347c45ec24ebed4bfe231547521d74c.png";